import { configureStore } from "@reduxjs/toolkit";
import authService from "./services/authService";
import categoryService from "./services/categoryService";
import productService from "./services/productService";
import paymentService from "./services/paymentService";
import orderService from "./services/orderService";
import userOrdersService from "./services/userOrdersService";
import homeProducts from "./services/homeProducts";
import homepageService from "./services/homepageService";
import checkoutService from "./services/checkoutService";
import customerSessionMiddleware from "./customerSessionMiddleware";

import authReducer from "./reducers/authReducer";
import globalReducer from "./reducers/globalReducer";
import cartReducer from "./reducers/cartReducer";

const Store = configureStore({
  reducer: {
    [authService.reducerPath]: authService.reducer,
    [categoryService.reducerPath]: categoryService.reducer,
    [productService.reducerPath]: productService.reducer,
    [homeProducts.reducerPath]: homeProducts.reducer,
    [homepageService.reducerPath]: homepageService.reducer,
    [paymentService.reducerPath]: paymentService.reducer,
    [orderService.reducerPath]: orderService.reducer,
    [userOrdersService.reducerPath]: userOrdersService.reducer,
    [checkoutService.reducerPath]: checkoutService.reducer,

    authReducer,
    globalReducer,
    cartReducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      customerSessionMiddleware,
      authService.middleware,
      categoryService.middleware,
      productService.middleware,
      homeProducts.middleware,
      homepageService.middleware,
      paymentService.middleware,
      orderService.middleware,
      userOrdersService.middleware,
      checkoutService.middleware,
    ]),
});

export default Store;
